import folder from "../images/folder.svg";

import user from "../images/user.svg";
export const resourceInfo = [
  {
    id: 1,
    icon: folder,
    title: "Blogs",
    text: "Learn about our story and our mission statement",
    link: "/blog",
  },
  {
    id: 2,
    icon: user,
    title: "FAQs",
    text: "Find everything you know about Knoct",
    link: "/question",
  },
];
